import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import { isEmpty } from "lodash";

import { ReactComponent as DownArrowSvg } from "assets/images/heylime-layout/pricing-arrow.svg";
import Alert from "components/shared/common/alert";
import ChargebeeIframe from "components/ChargebeeIframe";
import {
  getSubscription,
  listSubscription,
  updateSubscription
} from "pages/billing/api";
import { setIsLoading } from "redux/loader/action";
import { setCurrentUser } from "redux/game/action";

const PricingComponent = () => {
  const dispatch = useDispatch();
  const { gameReducer: { currentUser, gamesData } = {} } = useSelector(
    (state) => state
  );

  const teamId = currentUser?.team?.id;
  const teamCount = currentUser?.team?.count;
  const AnnualPlanState = currentUser?.team?.AnnualPlanState;
  const plans_details =
    gamesData.pricing_flow.pricing.trial_ended.from_trial_plans;

  const [teamName, setTeamName] = useState(currentUser.team?.description || "");
  const [chargebeeUrl, setChargebeeUrl] = useState("");
  const [planDropdownOpen, setPlanDropdownOpen] = useState(false);
  const [selectedPlanDetails, setSelectedPlanDetails] = useState(
    plans_details[0]
  );

  const handleIsLoading = (value) => dispatch(setIsLoading(value));

  useEffect(() => {
    const did_mount = async () => {
      handleIsLoading(true);

      let listPayload = { team_code: teamId };
      if (AnnualPlanState != null) {
        listPayload.state = "non_renewing";
      }

      try {
        const paymentDetailsRes = await listSubscription(listPayload);
        if (paymentDetailsRes.list) return;
        const plan = plans_details?.find(
          (item) =>
            item.planPriceId ===
            paymentDetailsRes.subscription_items[0].item_price_id
        );
        setSelectedPlanDetails(plan);
      } catch (error) {
      } finally {
        handleIsLoading(false);
      }
    };

    if (currentUser.team.status === "PAID") did_mount();
  }, [JSON.stringify(currentUser)]);

  const togglePlanDropdown = () => setPlanDropdownOpen(!planDropdownOpen);

  const handleSelectPlan = (price) => {
    const plan = plans_details.find((item) => item.Price === price);
    setSelectedPlanDetails(plan);
    togglePlanDropdown();
  };

  const onCheckout = async () => {
    handleIsLoading(true);

    let listPayload = { team_code: teamId };
    if (AnnualPlanState != null) {
      listPayload.state = "non_renewing";
    }
    const paymentDetailsRes = await listSubscription(listPayload);

    const plan_name = paymentDetailsRes.list
      ? null
      : paymentDetailsRes.subscription_items[0].item_price_id;
    dispatch(setCurrentUser({ ...currentUser, plan_name: plan_name }));

    let urlData = "";
    if (currentUser.team.status === "TRIAL") {
      const name = currentUser.username.split(" ");
      urlData = await getSubscription({
        id: currentUser.email,
        item_price_id: selectedPlanDetails.planPriceId,
        quantity: teamCount,
        first_name: name[0],
        last_name: name[1],
        team_name: teamId
      });
    } else {
      urlData = await updateSubscription({
        subscription_id: paymentDetailsRes.id,
        email: currentUser.email,
        item_price_id: selectedPlanDetails.planPriceId,
        quantity: teamCount
      });
    }

    if (!isEmpty(urlData?.hosted_page?.url))
      setChargebeeUrl(urlData.hosted_page.url);
    else {
      handleIsLoading(false);
      Alert(400, urlData);
    }
  };

  const handleContinue = () => {
    const { team, userId } = currentUser;

    if (isEmpty(currentUser.team))
      return Alert(400, "You must be part of a team.");
    if (selectedPlanDetails.Price === 0)
      return Alert(400, "You must choose a Perform plan.");
    if (userId !== team.manager)
      return Alert(400, "You must be the host of the team.");
    if (team.AnnualPlanState != null)
      return Alert(400, "You have an active yearly subscription.");

    onCheckout();
  };

  const handleGetInTouch = () =>
    (window.open().location.href = "mailto:justin@heylime.com");

  return (
    <div className="pricing-new-main">
      <h2 className="title">Manage Plan</h2>
      <p className="desc signin">
        Welcome back, sign in to continue building team culture.
      </p>
      <input
        name="name"
        type="text"
        value={teamName}
        className="input-div"
        placeholder="Team Name"
        onChange={(e) => setTeamName(e.target.value)}
      />
      <Dropdown isOpen={planDropdownOpen} toggle={togglePlanDropdown}>
        <DropdownToggle caret>
          {selectedPlanDetails.name}
          <DownArrowSvg />
        </DropdownToggle>
        <DropdownMenu>
          {plans_details.map((plan, index) => (
            <DropdownItem
              key={index}
              onClick={() => handleSelectPlan(plan.Price)}
            >
              {plan.name}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>

      <div className="plan-details">
        <div className="plan-quantity">
          <span className="plan-text">{selectedPlanDetails.name}</span>
          <span className="plan-text">{teamCount || 0}</span>
        </div>
        <span className="plan-text price">{selectedPlanDetails.display}</span>
        <div className="plan-quantity">
          <span className="plan-text bold-text">Total</span>
          <span className="plan-text bold-text">
            {`$${(selectedPlanDetails.Price * teamCount || 0).toFixed(2)}`}
          </span>
        </div>
      </div>

      <button className="onboarding-button" onClick={handleContinue}>
        Continue
      </button>
      <p className="pricing-bottom-text">
        Payment is confirmed on next screen. If you wish to work with an account
        manager: <span onClick={handleGetInTouch}>Get in Touch Here</span>
      </p>

      {chargebeeUrl !== "" && (
        <ChargebeeIframe
          url={chargebeeUrl}
          onCLose={() => setChargebeeUrl("")}
          finishLoading={() => handleIsLoading(false)}
        />
      )}
    </div>
  );
};

export default PricingComponent;
